import store from '../store/store'

/* eslint-disable no-console, no-irregular-whitespace */
export default {
  replace: function(str) {
    if (typeof str !== 'string')
      return str

    var terms = (store.getters.getTerms || {}).Lookup || {}

    // Handle references to form fields
    terms.FirstName = store.getters.getFirstNameTerm
    terms.EmployerName = store.getters.getEmployerNameTerm
    terms.CompanyName = store.getters.getCompanyNameTerm

    return str.replace(/{{([a-zA-Z0-9\-_\.\']*)}}/g, function (match, key) {
      if (typeof terms[key] !== 'undefined')
        return terms[key]

        return key
    })
  }
}
